import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Icon } from "../../components/Icon/Icon";
import Information from "../../icons/information.svg";
import { useTranslations } from "../../providers/useTranslations";
import { FormattedPrice } from "../FormattedPrice";
import { I18n } from "../I18n";
import styles from "./MessageLimit.module.scss";
export const MessageLimit = ({ className = "", variantCompact = false, productLimitCurrency, productLimit = 0, displayStatus, }) => {
    const { __ } = useTranslations();
    if (displayStatus === false) {
        return null;
    }
    const classNameString = classNames({
        [styles.regular]: !variantCompact,
        [styles.compact]: !!variantCompact,
        [styles.show]: displayStatus,
        className,
    });
    return (_jsxs("div", { className: classNameString, children: [_jsx(Icon, { component: Information, width: !variantCompact ? "40px" : "30px", height: !variantCompact ? "40px" : "30px" }), _jsx("h4", { children: __("com.communication.text_message.limit_title") }), _jsx("p", { children: _jsx(I18n, { t: "com.communication.text_message.limit_warning", children: _jsx(FormattedPrice, { value: productLimit, currency: productLimitCurrency }) }) })] }));
};
//# sourceMappingURL=MessageLimit.js.map